module.exports = __webpack_public_path__ + "img/iran.eee43464.png";